<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Sad, Sardonic and Hopeful</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#about-the-poet">About the Poet</a></li>
<li id="toc-li-6"><span href="#/text/ch006#be-kind" title="Link target outside of Sample">Be Kind</span></li>
<li id="toc-li-7"><span href="#/text/ch007#the-song-has-lost-all-meaning" title="Link target outside of Sample">The Song has Lost all Meaning</span></li>
<li id="toc-li-8"><span href="#/text/ch008#home-improvement" title="Link target outside of Sample">Home Improvement</span></li>
<li id="toc-li-9"><span href="#/text/ch009#a-letter-from-a-drowning-nation" title="Link target outside of Sample">A Letter from a Drowning Nation</span></li>
<li id="toc-li-10"><span href="#/text/ch010#an-incompetent-announcement" title="Link target outside of Sample">An Incompetent Announcement</span></li>
<li id="toc-li-11"><span href="#/text/ch011#a-break-down-that-started-in-2018" title="Link target outside of Sample">A Break Down (That Started in 2018)</span></li>
<li id="toc-li-12"><span href="#/text/ch012#trumpeting-clown" title="Link target outside of Sample">Trumpeting Clown</span></li>
<li id="toc-li-13"><span href="#/text/ch013#gaia" title="Link target outside of Sample">Gaia</span></li>
<li id="toc-li-14"><span href="#/text/ch014#foresight" title="Link target outside of Sample">Foresight</span></li>
<li id="toc-li-15"><span href="#/text/ch015#missed-autumn" title="Link target outside of Sample">Missed Autumn</span></li>
<li id="toc-li-16"><span href="#/text/ch016#an-indescribable-thing" title="Link target outside of Sample">An Indescribable Thing</span></li>
<li id="toc-li-17"><span href="#/text/ch017#false-pretences" title="Link target outside of Sample">False Pretences</span></li>
<li id="toc-li-18"><span href="#/text/ch018#a-great-showman" title="Link target outside of Sample">A Great Showman</span></li>
<li id="toc-li-19"><span href="#/text/ch019#you" title="Link target outside of Sample">You</span></li>
<li id="toc-li-20"><span href="#/text/ch020#am-i" title="Link target outside of Sample">Am I?</span></li>
<li id="toc-li-21"><span href="#/text/ch021#whispers" title="Link target outside of Sample">Whispers</span></li>
<li id="toc-li-22"><span href="#/text/ch022#balloon" title="Link target outside of Sample">Balloon</span></li>
<li id="toc-li-23"><span href="#/text/ch023#helpless" title="Link target outside of Sample">Helpless</span></li>
<li id="toc-li-24"><span href="#/text/ch024#deep-blue" title="Link target outside of Sample">Deep Blue</span></li>
<li id="toc-li-25"><span href="#/text/ch025#grumpelstiltskin" title="Link target outside of Sample">Grumpelstiltskin</span></li>
<li id="toc-li-26"><span href="#/text/ch026#stone-cold" title="Link target outside of Sample">Stone Cold</span></li>
<li id="toc-li-27"><span href="#/text/ch027#time" title="Link target outside of Sample">Time</span></li>
<li id="toc-li-28"><span href="#/text/ch028#quantum" title="Link target outside of Sample">Quantum</span></li>
<li id="toc-li-29"><span href="#/text/ch029#mummys-little-helper" title="Link target outside of Sample">Mummy’s Little Helper</span></li>
<li id="toc-li-30"><span href="#/text/ch030#from-the-ears-of-babes" title="Link target outside of Sample">From the Ears of Babes</span></li>
<li id="toc-li-31"><span href="#/text/ch031#days-gone-by" title="Link target outside of Sample">Days Gone By</span></li>
<li id="toc-li-32"><span href="#/text/ch032#no-more" title="Link target outside of Sample">No More</span></li>
<li id="toc-li-33"><span href="#/text/ch033#parlez-vous-anglais" title="Link target outside of Sample">Parlez-Vous Anglais?</span></li>
<li id="toc-li-34"><span href="#/text/ch034#trick-or-treat" title="Link target outside of Sample">Trick? Or Treat?</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?2a4abc34